import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {ENTER} from "@angular/cdk/keycodes";
import {FormBuilder, FormControl} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {UsefulFunctionsService} from "../useful-functions.service";
import {ChipsListComponent} from "../chips-list/chips-list.component";
import {MatChipInputEvent} from "@angular/material/chips";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {environment} from "../../environments/environment";

//TODO create as a global interface?
interface chipElement {
  arrayString: string[];
  formArrayName: string;
}

export interface AlertINCI {
  name: string;
  "Petrochemicals": number,
  "Irritating Alcohols": number,
  "Endocrine Disruptors": number,
  "Palm Oil": number,
  "Silicones": number,
  "Perfluorinated, polyfluorinated and related substances": number,
  "Chemical sensitisers  (preservatives)": number,
  "Conscious Consumer": number,
  "Vegan": number,
  "Aluminum": number,
  "European Chemicals Agency - High Concern List": number,
  "Plastics": number,
  "Fragrance Allergens": number,
  "Chemical sensitisers  (colorants)": number,
  "Aluminum in deodorant": number,
  "UV-Filter Concern List": number,
  "Nail Products Concern List": number,
  "Fluorides in Oral Hygiene": number,
  "Formaldehyde": number,
  "Phthalates": number,
  "Parabens": number,
  "Triclosan": number,
  "Isothiazolinone": number,
  "List of Substances Prohibited in Cosmetic Products in European Union": number,
  "CMR Substances": number,
  "personal list": number
}


@Component({
  selector: 'app-inci-alerts',
  templateUrl: './inci-alerts.component.html',
  styleUrls: ['./inci-alerts.component.scss']
})
export class InciAlertsComponent implements OnInit {

  getINCIAlertsForm = this.fb.group({
    INCIs: this.fb.array([]),
  });

  results: any //The JSON object that will contain the results from the request

  //Chips boolean, TODO move into the chip list component
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER];

  //Element from a chip input form control, we can certainly do a class or interface with it but the @ViewChild is posing problem
  INCICtrl = new FormControl(); //FormControl for the EAN input
  @ViewChild('INCIInput') INCIInput: ElementRef<HTMLInputElement>;
  INCIChipElement: chipElement= {
    arrayString: [],
    formArrayName: 'INCIs',
  }

  inputElements = [] //Array that will gather the different input defined as ElementRef

  //Initialize the 3 tables
  tables = [{
    title: "Alerts List Part 1",
    displayedColumns: ['name', "Petrochemicals",
      "Irritating Alcohols",
      "Endocrine Disruptors",
      "Palm Oil",
      "Silicones",
      "Perfluorinated, polyfluorinated and related substances",
      "Chemical sensitisers  (preservatives)",
      "Conscious Consumer",
      "Vegan",
      "Aluminum"],
    dataSource: []
  }, {
    title: "Alerts List Part 2",
    displayedColumns: ['name',
      "Aluminum",
      "European Chemicals Agency - High Concern List",
      "Plastics",
      "Fragrance Allergens",
      "Chemical sensitisers  (colorants)",
      "Aluminum in deodorant",
      "UV-Filter Concern List",
      "Nail Products Concern List",
      "Fluorides in Oral Hygiene",
    ],
    dataSource: []
  },{
    title: "Hazards List",
    displayedColumns: [ 'name', "Formaldehyde",
      "Phthalates",
      "Parabens",
      "Triclosan",
      "Isothiazolinone",
      "List of Substances Prohibited in Cosmetic Products in European Union",
      "CMR Substances"],
    dataSource: []
  }]

  constructor(private fb: FormBuilder,
              public httpClient: HttpClient,
              public usefulFunctionsService: UsefulFunctionsService,
              public chipListComponent: ChipsListComponent) {

    this.INCICtrl.valueChanges.subscribe(async (inci: any) => {
      this.usefulFunctionsService.possibleINCIs = await this.usefulFunctionsService.searchIngredients(inci)
    })
  }

  ngOnInit(): void {
  }

  /**
   * Manage the add event from a MapChipInput
   * @param event,MatChipInputEvent, the event of adding a chip
   * @param formControl, the formControl linked to the input
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param inci, boolean indicating whether we are dealing with an INCI input or not
   * @source: https://material.angular.io/components/chips/api
   */
  add(event: MatChipInputEvent, formControl, array, formArrayName, inci:boolean): void {
    const input = event.input;
    const value = event.value;

    this.chipListComponent.addChip(value, null, array, formArrayName, formControl, this.getINCIAlertsForm, inci)

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  /**
   * Manage the add event from a MatAutocompleteSelectedEvent, by adding a chip and the value into the formControl
   * @param event, MatAutocompleteSelectedEvent, the selection event
   * @param formControl, the formControl linked to the input
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param inci, boolean indicating whether we are dealing with an INCI input or not
   * @source: https://material.angular.io/components/chips/api
   */
  selected(event: MatAutocompleteSelectedEvent, formControl, array, formArrayName, inci:boolean): void {

    this.inputElements = [this.INCIInput] //Pass all the inputs that can be selected in the array

    const value = inci ? event.option.viewValue: event.option.value;
    const viewValue = event.option.viewValue;

    //Clean all the inputs value as we cannot select the current input as native element
    this.inputElements.forEach(nativeElement => {
      nativeElement.nativeElement.value = ''
    })

    this.chipListComponent.addChip(value, viewValue, array, formArrayName, formControl, this.getINCIAlertsForm, inci)
  }

  /**
   * Manage the form submission
   */
  async onSubmit() {

    this.results = null
    //this.getINCIInformationForm.value.skip = this.skip

    var tokenData: any = await this.httpClient.post(environment.apiUrl+"temptoken", {"id":sessionStorage.getItem('id')}).toPromise()

    var bodyPredefinedForTest = {"INCIs": ["AQUA", "ISOBUTYLPARABEN"]}

    //ToPromise convert an Observable to a Promise (more info here: https://blog.fullstacktraining.com/angular-promise-vs-observable/)
    var data = await this.httpClient.post(environment.apiUrl+"belongToAlerts",
      //bodyPredefinedForTest,
      this.getINCIAlertsForm.value,
      {"headers": {
          "Authorization": "Bearer " + tokenData.token,
          "Content-Type": "application/json"
        }}).toPromise()

    this.results = data
    this.tables.forEach(table => table.dataSource = data["data"])

  }
}
